import loggerRegistry from 'ia-react-core/~/services/log/loggerRegistry';
import createLogger, { CreateLoggerOptions } from './createLogger';

const getLogger = ({ namespace = 'App', ...options }: CreateLoggerOptions = {}) => (
  loggerRegistry[namespace] || createLogger({ namespace, ...options })
);

/**
 * @component
 * @visibleName createLogger
 */
export default getLogger;
